/* eslint-disable no-console, no-underscore-dangle,
newline-after-var, id-match,  operator-linebreak, prefer-reflect, arrow-body-style */
import Popper from 'popper.js';
import { addEvent, removeEvent } from '../utils/events';
import { htmlFromString } from '../utils/html';

// const ARROW_HEIGHT = 20;
const CLASS_PREFIX = 'tooltip';
// const BSCLS_PREFIX_REGEX = new RegExp(`(^|\\s)${ CLASS_PREFIX }\\S+`, 'g');

const Default = {
  animation: true,
  template: `
    <div class="tooltip">
      <div class="tooltip__inner"></div>
      <div class="tooltip__arrow"></div>
    </div>
  `,
  trigger: [ 'hover', 'focus' ],
  title: '',
  delay: 0,
  html: false,
  selector: false,
  placement: 'top',
  offset: 0,
  container: false,
  fallbackPlacement: 'flip',
  boundary: 'scrollParent',
  theme: false,
};

const AttachmentMap = {
  AUTO: 'auto',
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
};

const HoverState = {
  SHOW: 'show',
  OUT: 'out',
};
//
const Selector = {
  // TOOLTIP: '.tooltip',
  ARROW: `.${ CLASS_PREFIX }__arrow`,
  TOOLTIP_INNER: `.${ CLASS_PREFIX }__inner`,
};

const ClassName = {
  ANIMATE: `${ CLASS_PREFIX }--animate`,
  SHOW: `${ CLASS_PREFIX }--show`,
};

export class Tooltip {

  /**
   * @param  {Dom}       element       tooltip element
   * @param  {Object}    config        configuration
   */
  constructor(element, config) {
    this._themes = [ 'light', 'error', 'alternative', 'white' ];

    this.element = element;
    this.config = this._getConfig(config);

    if (!this._healthCheck()) {
      return;
    }

    this.addTooltip = this.addTooltip.bind(this);
    this.removeTooltip = this.removeTooltip.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.checkForScollVal = this.checkForScollVal.bind(this);

    this.magicNumberForOffsetInPixels = 20;
    this.magicNumberForTooltipMaxSizeProportion = 1.5;

    this.tooltipOpen = false;

    // Initialize accordion
    this._setListeners();
  }

  checkForScollVal() {
    let currentElement = this.tooltipElement;
    let reachedBody = false;
    let scrollTop = 0;
    let scrollLeft = 0;
    do {
      if (currentElement.tagName === 'BODY') {
        reachedBody = true;
      } else if (
        /(auto|scroll|overlay)/.test(currentElement.style.overflow) ||
        /(auto|scroll|overlay)/.test(currentElement.style.overflowX) ||
        /(auto|scroll|overlay)/.test(currentElement.style.overflowY)
      ) {
        scrollTop += currentElement.scrollTop;
        scrollLeft += currentElement.scrollLeft;
        currentElement = currentElement.parentNode;
      } else {
        currentElement = currentElement.parentNode;
      }
    } while (reachedBody === false);
    return {
      top: scrollTop,
      left: scrollLeft,
    };
  }

  addTooltip() {
    this.tooltipOpen = true;

    // Get text
    this.title = this.getTitle();

    const tooltipLength = 140;
    // Limit tooltip limit to 140 chars
    if (this.title.length > tooltipLength) {
      return false;
    }

    // Remove text from target node
    this.element.removeAttribute('title');

    // Add tooltip to document
    const tooltip = this.getTipElement();

    this.setContent();

    if (this.config.animation) {
      tooltip.classList.add(ClassName.ANIMATE);
    }

    this._setTheme(this.config.theme);

    const placement = typeof this.config.placement === 'function'
      ? this.config.placement.call(this, tooltip, this.element)
      : this.config.placement;

    const attachment = this._getAttachment(placement);
    this.addAttachmentClass(attachment);

    const container = this.config.container === false ? document.body : document.querySelector(this.config.container);
    container.appendChild(tooltip);

    this._popper = new Popper(this.element, tooltip, {
      placement: attachment,
      modifiers: {
        offset: {
          offset: this.config.offset,
        },
        flip: {
          behavior: this.config.fallbackPlacement,
        },
        arrow: {
          element: Selector.ARROW,
        },
        preventOverflow: {
          boundariesElement: this.config.boundary,
        },
      },
      onCreate: (info) => {
        if (info.originalPlacement !== info.placement) {
          this._handlePopperPlacementChange(info);
        }
      },
      onUpdate: (info) => {
        this._handlePopperPlacementChange(info);
      },
    });

    tooltip.classList.add(ClassName.SHOW);
    return true;
  }

  destroy() {
    this.removeTooltip();
    removeEvent(this.element, 'mouseenter', this.addTooltip);
    removeEvent(this.element, 'mouseleave', this.removeTooltip);
    removeEvent(this.element, 'touchend', this.toggleTooltip);
  }

  // Helpers

  toggleTooltip() {
    this.tooltipOpen ? this.removeTooltip() : this.addTooltip();
  }

  removeTooltip() {
    if (this.tooltipOpen) {
      const tooltip = this.getTipElement();
      if (this._hoverState !== HoverState.SHOW && tooltip.parentNode) {
        tooltip.parentNode.removeChild(tooltip);
      }
      this.tooltipOpen = false;
    }
  }

  getTipElement() {
    this.tooltip = this.tooltip || this._buildTooltip();
    return this.tooltip;
  }

  setContent() {
    const tooltip = this.getTipElement();
    this.setElementContent(tooltip.querySelector(Selector.TOOLTIP_INNER), this.getTitle());
    // tooltip.removeClass(`${ ClassName.FADE } ${ ClassName.SHOW }`);
  }

  setElementContent(element, content) {
    const html = this.config.html;

    if (typeof content === 'object' && content.nodeType) {
      if (html) {
        if (content.parentNode === element) {
          while (element.firstChild) {
            element.removeChild(element.firstChild);
          }
          element.appendChild(content);
        }
      } else {
        element.textContent(content.textContent());
      }
    } else {
      element[html ? 'innerHTML' : 'textContent'] = content;
    }
  }

  addAttachmentClass(attachment) {
    this.getTipElement().classList.add(`${ CLASS_PREFIX }--${ attachment }`);
  }

  getTitle() {
    let title = this.element.getAttribute('data-original-title');

    if (!title) {
      title = typeof this.config.title === 'function'
        ? Reflect.apply(this.config.title, this.element)
        : this.config.title;
    }

    return title;
  }

  /* eslint-disable no-console */
  _healthCheck() {
    if (!this.element) {
      console.warn('CommonUI - Tooltip - There\'s no tooltip found');
      return false;
    }
    if (!this.element.attributes.title
      || (this.element.attributes.title.value !== '' && !this.element.attributes.title.value)) {
      console.warn('CommonUI - Tooltip - Tooltip is missing the title attribute');
      return false;
    }

    return true;
  }
  /* eslint-enable no-console */

  _setListeners() {
    addEvent(this.element, 'mouseenter', this.addTooltip);
    addEvent(this.element, 'mouseleave', this.removeTooltip);
    addEvent(this.element, 'touchstart touchend', this.toggleTooltip);

    if (this.config.selector) {
      this.config = {
        ...this.config,
        trigger: 'manual',
        selector: '',
      };
    } else {
      this._fixTitle();
    }
  }

  _getAttachment(placement) {
    return AttachmentMap[placement.toUpperCase()];
  }

  _fixTitle() {
    const titleType = typeof this.element.getAttribute('data-original-title');
    if (this.element.getAttribute('title') || titleType !== 'string') {
      this.element.setAttribute(
        'data-original-title',
        this.element.getAttribute('title') || ''
      );
      this.element.setAttribute('title', '');
    }
  }

  // _buildTooltip() {
  //   this.tooltip = htmlFromString(this.config.template);
  //
  //   return this.tooltip;
  // }

  _buildTooltip() {
    this.tooltip = htmlFromString(this.config.template);

    return this.tooltip;
  }

  _setTheme(theme) {
    if (theme !== null && typeof theme === 'string') {
      if (this._themes.indexOf(theme) >= 0) {
        this.tooltip.classList.add(`${ CLASS_PREFIX }--${ theme }`);
      } else {
        /* eslint-disable no-console */
        console.warn(`CommonUI - Tooltip - The theme ${ theme } does not exist`);
        /* eslint-enable no-console */
      }
    }
  }

  _getConfig(config) {
    config = {
      ...Default,
      ...typeof this.element.dataset === 'object' ? Object.assign({}, this.element.dataset) : {},
      ...typeof config === 'object' && config ? config : {},
    };

    if (typeof config.delay === 'number') {
      config.delay = {
        show: config.delay,
        hide: config.delay,
      };
    }

    if (typeof config.title === 'number') {
      config.title = config.title.toString();
    }

    if (typeof config.content === 'number') {
      config.content = config.content.toString();
    }

    return config;
  }

  _cleanAttachmentClass() {
    const tooltip = this.getTipElement();

    Object.keys(AttachmentMap).forEach((key) => {
      if (tooltip.classList.contains(`${ CLASS_PREFIX }--${ AttachmentMap[key] }`)) {
        tooltip.classList.remove(`${ CLASS_PREFIX }--${ AttachmentMap[key] }`);
      }
    });
  }

  _handlePopperPlacementChange(info) {
    this._cleanAttachmentClass();
    this.addAttachmentClass(this._getAttachment(info.placement));
  }
}

/**
 * @param  {Dom | String}  target     tooltip DOM object or selector string
 * @param  {Object}        config     config for tolltip
 */
// export default function initTooltip(target = 'abbr[rel="tooltip"]', config = {}) {
//   if (typeof target === 'string') {
//     target = document.querySelectorAll(target);
//   }
//
//   let tooltips = null;
//
//   for (const tooltip of target) {
//     tooltips = new Tooltip(tooltip, config);
//   }
//
//   return tooltips;
// }

export default function initTooltip(config = {}) {
  const { selector = 'abbr[rel="tooltip"]' } = config;
  let tooltips = null;
  if (typeof selector === 'string') {
    for (const tooltip of document.querySelectorAll(selector)) {
      tooltips = new Tooltip(tooltip, config);
    }
  }
  return tooltips;
}



// WEBPACK FOOTER //
// ./js/components/Tooltip.js